import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import sortBy from 'lodash/sortBy';
import { PACKAGE_ITEMS } from 'pap/ducks/workflow';
import FeaturesField from 'admin/components/features_field';

export function mapStateToProps({ admin }, { params }) {
  const { projects } = admin;

  const project = projects.currentProject || projects.list.find(({ id }) => (
    id === (params.projectId * 1)
  )) || {};
  /* only features presented in PAP */
  const features = (project.features || []).filter(({ feature }) => {
    return PACKAGE_ITEMS.find(item => [feature.name, feature.group].includes(item.name));
  }).map(({ feature }) => feature);

  return {
    /* active features first */
    features: sortBy(features, f => !f.active)
  };
}

export default withRouter(connect(mapStateToProps)(FeaturesField));



// WEBPACK FOOTER //
// ./admin/containers/features_field.js